export var MuiFormControl = {
    variant: 'outlined',
};
//# sourceMappingURL=MuiFormControl.js.map